<template>
  <div v-if="readingActive && showLogo">
    <svg
      width="154"
      height="154"
      viewBox="0 0 154 154"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M102.594 78.4999L112.523 88.4631C114.857 90.8058 114.857 94.6173 112.523 96.96L101.345 108.176L101.319 108.459C100.787 114.352 98.0843 119.707 93.7087 123.536C88.5549 128.045 81.681 130.534 74.9967 130.534C72.8044 130.534 70.6333 130.266 68.5493 129.714C67.7035 129.49 67.1979 128.62 67.4218 127.771C67.6449 126.922 68.5118 126.416 69.3576 126.64C76.8104 128.612 85.5518 126.452 91.6264 121.139C94.3746 118.733 96.3504 115.622 97.3948 112.14L88.7218 120.842C87.5911 121.978 86.0875 122.603 84.4878 122.603C82.8882 122.603 81.3846 121.978 80.2539 120.843L74.076 114.643H74.0751L67.596 108.142C67.7295 108.906 67.2899 109.674 66.5337 109.923C65.7025 110.199 64.8062 109.746 64.5319 108.912C62.4764 102.668 58.1236 97.602 52.2753 94.6475C51.2073 94.1067 49.9968 94.016 48.8636 94.3918C47.7296 94.7667 46.8097 95.564 46.2716 96.6349C45.7343 97.705 45.6448 98.9204 46.0193 100.058C46.3937 101.195 47.1874 102.118 48.253 102.657C51.9709 104.538 54.7362 107.758 56.0412 111.725C56.051 111.753 56.0599 111.783 56.0672 111.812C56.09 111.895 58.4142 120.324 64.5066 124.501C65.2287 124.997 65.4143 125.986 64.921 126.711C64.6141 127.162 64.1167 127.404 63.6112 127.404C63.3035 127.404 62.9917 127.314 62.719 127.127C55.8271 122.403 53.2465 113.509 53.0194 112.683C51.9741 109.54 49.777 106.989 46.8276 105.497C45.0057 104.576 43.6495 102.999 43.0105 101.056C42.3706 99.1108 42.5237 97.0335 43.4419 95.2046C44.3602 93.3748 45.933 92.0139 47.8704 91.3719C48.7317 91.0868 49.619 90.9602 50.4999 90.9872L38.5225 78.968C36.1878 76.6252 36.1878 72.8138 38.5225 70.4711L56.1552 52.778C56.7738 52.1564 57.7776 52.1564 58.3963 52.778C59.015 53.3988 59.015 54.4052 58.3963 55.026L40.7628 72.7199C39.6639 73.8226 39.6639 75.6172 40.7628 76.7192L43.9686 79.9359C44.2218 79.307 44.602 78.718 45.1091 78.2091L70.0341 53.1979C70.534 52.6963 71.1177 52.3099 71.7534 52.0518L70.8897 51.1843C70.8893 51.1843 70.8891 51.1841 70.8889 51.1839L70.8885 51.1836L70.8881 51.1835C70.8881 51.1827 70.8881 51.1827 70.8873 51.1827L68.5501 48.8375C68.0185 48.3033 67.3103 48.0092 66.5573 48.0092C65.8051 48.0092 65.0968 48.3033 64.5644 48.8375L62.9738 50.4328C62.3551 51.0536 61.3521 51.0544 60.7335 50.4328C60.1148 49.812 60.1148 48.8056 60.7335 48.1848L62.3241 46.5887C63.4549 45.4541 64.9584 44.8292 66.5573 44.8292C68.1569 44.8292 69.6605 45.4541 70.7912 46.5887L72.1344 47.9357C73.27 47.2136 74.588 46.8248 75.9654 46.8248C77.8833 46.8248 79.6865 47.5738 81.0419 48.9347C82.3981 50.2956 83.1455 52.1049 83.1455 54.0286C83.1455 55.4115 82.758 56.7332 82.0383 57.8735L84.7801 60.6247C87.5536 58.8685 91.2722 59.2001 93.6868 61.6229C95.043 62.983 95.7895 64.7923 95.7895 66.7168C95.7895 66.9798 95.7748 67.2412 95.7472 67.4993C97.8344 67.2731 100.003 67.96 101.599 69.5627C104.014 71.9847 104.344 75.7169 102.594 78.4999ZM100.248 76.1452C100.82 74.6969 100.525 72.9807 99.3597 71.8109C98.1932 70.6412 96.4828 70.3447 95.0395 70.9189L100.248 76.1452ZM91.4462 63.8715C92.2041 64.632 92.6209 65.6424 92.6209 66.7174C92.6209 67.2361 92.5216 67.7393 92.336 68.2074L87.1268 62.9803C88.5701 62.4052 90.2805 62.7018 91.4462 63.8715ZM78.802 51.183C78.0441 50.4225 77.0372 50.0043 75.9658 50.0043C75.4489 50.0043 74.9474 50.1039 74.4818 50.2902L79.6918 55.518C79.8774 55.05 79.9767 54.5468 79.9767 54.0281C79.9767 52.9531 79.5591 51.9427 78.802 51.183ZM47.35 83.3297C46.5612 82.5374 46.5612 81.2492 47.35 80.4577L72.2758 55.4472C72.6584 55.0633 73.1664 54.8526 73.7069 54.8526C74.2475 54.8526 74.7554 55.0633 75.1372 55.4472L104.104 84.5125C104.893 85.3041 104.893 86.5931 104.104 87.3846L79.1791 112.395C78.3894 113.187 77.1065 113.187 76.3168 112.396L47.35 83.3297ZM98.6936 106.34L110.283 94.7116C111.382 93.6088 111.382 91.815 110.283 90.7123L107.485 87.9056C107.232 88.5345 106.852 89.1243 106.345 89.6332L81.42 114.644C80.912 115.153 80.325 115.534 79.6982 115.788L82.4953 118.595C83.0269 119.129 83.7351 119.423 84.4882 119.423C85.2404 119.423 85.9486 119.129 86.481 118.595L98.6911 106.343L98.6936 106.34Z"
        fill="#C4C4C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M96.2788 102.294C95.6796 102.294 95.1171 102.528 94.6946 102.953C93.8211 103.829 93.8211 105.255 94.6946 106.131C95.1171 106.556 95.6796 106.789 96.2788 106.789C96.8771 106.789 97.4396 106.556 97.8621 106.131C98.7356 105.254 98.7356 103.829 97.8621 102.953C97.4396 102.528 96.8771 102.294 96.2788 102.294Z"
        fill="#C4C4C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M52.3729 67.5432L59.4064 60.4856C60.0259 59.8648 60.0259 58.8584 59.4064 58.2376C58.7877 57.616 57.7848 57.616 57.1661 58.2376L50.1326 65.2952C49.5139 65.916 49.5139 66.9224 50.1326 67.5432C50.4419 67.8544 50.8473 68.0096 51.2527 68.0096C51.6582 68.0096 52.0636 67.8544 52.3729 67.5432Z"
        fill="#C4C4C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.001 68.1169C49.2268 66.9783 47.4033 67.3172 47.1298 68.6871C46.8424 70.1313 48.5902 71.1622 49.7063 70.2114C50.3087 69.6984 50.4463 68.7778 50.001 68.1169Z"
        fill="#C4C4C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M74.4025 45.4922C74.7119 45.8026 75.1181 45.9578 75.5235 45.9578C75.9289 45.9578 76.3343 45.8026 76.6437 45.4922C77.2624 44.8714 77.2624 43.8642 76.6437 43.2434C71.082 37.6635 62.0328 37.6635 56.4712 43.2434C55.8525 43.865 55.8525 44.8714 56.4712 45.4922C57.0898 46.113 58.0936 46.113 58.7123 45.4922C63.0382 41.1515 70.0766 41.1515 74.4025 45.4922Z"
        fill="#C4C4C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M81.0484 40.415C81.4538 40.415 81.8593 40.2598 82.1686 39.9494C82.7873 39.3286 82.7873 38.3223 82.1686 37.7015C77.999 33.5175 72.4544 31.2124 66.5581 31.2124C60.6602 31.2124 55.1164 33.5167 50.9468 37.7015C50.3281 38.3223 50.3281 39.3286 50.9468 39.9494C51.5655 40.5702 52.5692 40.5702 53.1879 39.9494C56.7584 36.3659 61.5068 34.3924 66.5573 34.3924C71.6077 34.3924 76.3562 36.3659 79.9275 39.9494C80.2368 40.2598 80.6422 40.415 81.0484 40.415Z"
        fill="#C4C4C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.7187 34.462C58.1062 24.039 75.0086 24.039 85.3961 34.462C85.7046 34.7724 86.1108 34.9276 86.5162 34.9276C86.9216 34.9276 87.327 34.7724 87.6364 34.462C88.2551 33.8412 88.2551 32.8348 87.6364 32.2132C76.0132 20.551 57.1008 20.551 45.4776 32.2132C44.8589 32.8348 44.8589 33.8412 45.4776 34.462C46.0971 35.0828 47.1001 35.0828 47.7187 34.462Z"
        fill="#C4C4C4"
      />
    </svg>
  </div>
</template>

<script setup>
// @ts-check
import { HiNotification } from '@/js/common/HINotificationSupport';
import { DispositivoConNFCHabilitado, DispositivoSoportaNFC } from '@/js/common/HiNFCSupport';
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  active: {
    type: Boolean,
    default: true,
  },
  showLogo: {
    type: Boolean,
    default: true,
  },
  // Algunas tarjeta NFC retornan el id de la tarjeta en "reversed" Ej:  id: Array(4) = [-48, -109, -10, 32]
  // en Hexadecimal = 20 f6 93 d0 en decimal = 553030608 si trabajamos en modo reversed el mismo array en Hexadecimal
  // será d0 93 f6 20 en decimal 3499357728
  reversed: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  /** Se emite al activar el componente cuando el dispositivo no soporta lectura mediante NFC. */
  'nfcNoSoportado',
  'nfcScan',
]);

const { t } = useI18n();
const hasDeviceNFCSupport = ref(false);
const isDeviceNFCEnabled = ref(false);
const isNFCListenerRegistered = ref(false);

const readingActive = computed(() => props.active
  && hasDeviceNFCSupport.value
  && isDeviceNFCEnabled.value
  && isNFCListenerRegistered.value);

watch(() => props.active, (val) => {
  if (val) {
    if (hasDeviceNFCSupport.value && isDeviceNFCEnabled.value) {
      enableNFCListener();
    }
  } else {
    finishNFCListener();
  }
});

function enableNFCListener() {
  const onAddListenerError = () => {
    HiNotification.Toast(t('nfcReading.notSupported'), 4000);
    emit('nfcNoSoportado');
    isNFCListenerRegistered.value = false;
  };

  if (!window.nfc) {
    onAddListenerError();
    return;
  }

  const onAddListenerSuccess = () => {
    isNFCListenerRegistered.value = true;
  };

  window.nfc.addTagDiscoveredListener(handleNewTagEvent, onAddListenerSuccess, onAddListenerError);
}

/**
 * @param {PhoneGapNfc.TagEvent} nfcEvent
 * @returns {void}
 */
function handleNewTagEvent(nfcEvent) {
  if (!window.nfc) {
    return;
  }

  const { tag } = nfcEvent;
  let tagHex = '';
  if (!props.reversed) {
    tagHex = window.nfc.bytesToHexString(tag.id.reverse());
  } else {
    tagHex = window.nfc.bytesToHexString(tag.id);
  }
  const tagDec = Number.parseInt(tagHex, 16);
  emit('nfcScan', tagDec);
}

function finishNFCListener() {
  if (!window.nfc) {
    return;
  }

  const onRemoveListenerSuccess = () => {
    isNFCListenerRegistered.value = false;
  };

  window.nfc.removeTagDiscoveredListener(handleNewTagEvent, onRemoveListenerSuccess);
}

onMounted(async () => {
  hasDeviceNFCSupport.value = await DispositivoSoportaNFC();
  isDeviceNFCEnabled.value = await DispositivoConNFCHabilitado();

  if (props.active && hasDeviceNFCSupport.value && isDeviceNFCEnabled.value) {
    enableNFCListener();
  }
});

onBeforeUnmount(() => {
  finishNFCListener();
});
</script>

<style scoped lang="scss">
svg {
  width: 64px;
  height: 64px;
}

@keyframes nfc {
  50% { fill: #fff; }
}

path {
  animation: nfc 2s infinite;
}
path:nth-child(1) { animation-delay: -0.7s; }
path:nth-child(2) { animation-delay: -0.6s; }
path:nth-child(3) { animation-delay: -0.5s; }
path:nth-child(4) { animation-delay: -0.4s; }
path:nth-child(5) { animation-delay: -0.3s; }
path:nth-child(6) { animation-delay: -0.2s; }
path:nth-child(7) { animation-delay: -0.1s; }
</style>
